<template>
  <div
    v-if="!loadingTheme"
    id="app"
    :class="{'loading-theme': loadingTheme}"
  >
    <div class="main">
      <router-view />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'App',
    props: {
      theme: {
        type: String,
        default: null,
      },
    },
    data() {
      return {
        loadingTheme: true,
      };
    },
    mounted() {
      this.addTheme();
    },
    methods: {
      async addTheme() {
        if (this.theme) {
          const element = document.createElement('link');
          element.setAttribute('rel', 'stylesheet');
          element.setAttribute('type', 'text/css');
          element.setAttribute('href', `/themes/${this.theme}/theme.css`);
          element.addEventListener('load', () => { this.loadingTheme = false; });
          document.getElementsByTagName('head')[0].appendChild(element);
        } else {
          this.loadingTheme = false;
        }
      },
    },
  };
</script>

<style lang="stylus" src="@/style/reset.styl"></style>
<style src="@/style/fonts.css"></style>
<style lang="stylus" src="@/style/global.styl"></style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="stylus" src="@/style/theme.styl"></style>

<style lang="stylus">
  .loading-theme
    *
      transition: none !important
</style>
